module.exports = __webpack_public_path__ + "static/media/PLA_test_report_pdf.425d5a67.pdf";